import $ from "jquery";
import { gsap } from "gsap";
import * as eS from "../../serch_modules/snmslider/snmslider";

/**
 * @author Sergio Gabriel Navarro Márquez
 * eMovilidad, Soluciones en Tecnología
 * 
 */
//**********************************             Inicia Sección          ****/
//**********************************             Termina Sección          ****/
//Declara Objeto con propiedades y métodos globales
var eG = {};
//Variables generales
//Detecta páginas
eG.pageId = $("body").attr("id");
eG.esIndex = eG.pageId == "snmhome";
eG.esOmedios = eG.pageId =="otrosmedios";
eG.esHabitat = eG.pageId =="habitat";
eG.esOobras = eG.pageId =="otrasobras";
eG.esGallery = eG.pageId =="gallery";
//*************************************         Variables Tamaño Pantalla
eG.headerH = 100;
eG.mqPoints = [960, 768, 500, 414, 375, 320];
eG.recalcWinPars = function() {
        //Esta función se ejecuta en window.resize y recalcula las medidas del viewport y elementos
        //Se ejecuta al iniciar cualquier página
        eG.altoViewport = $(window).height();           
        eG.anchoViewport = $(window).width();
        eG.altoMain = eG.altoViewport - eG.headerH;
        if (eG.anchoViewport > eG.mqPoints[0]) {
            $("#menuwrap").removeClass("mobile-on");
        }
    };
eG.recalcWinPars();
eG.setActiveMenuOption = function () {
    if ( !eG.esGallery ) {
        // La clase active se asigna desde php para las galerías o proyectos-detalle
        $("#mainmenulist li").removeClass("active");
    }
    switch (true) {
        case eG.esIndex:
            $("#mainmenulist li:nth-child(1)").addClass("active");
            break;
        case eG.esHabitat:
            $("#mainmenulist li:nth-child(2)").addClass("active");
            break;
        case eG.esOobras:
            $("#mainmenulist li:nth-child(3)").addClass("active");
            break;
        case eG.esOmedios:
            $("#mainmenulist li:nth-child(4)").addClass("active");
            break;
        default:
            break;
    }
};
eG.setAnimaLogo = function () {
    //A cada path snmdraw le asigna los atributos 
    //stroke-dasharray y stroke-dashoffset
    //con las longitudes de sus contornos
    $("#svgintro .snmdraw").each(function (){
        var longlinea = this.getTotalLength();
        $(this).attr({"stroke-dasharray" : longlinea + " " + longlinea,
                      "stroke-dashoffset" : longlinea,
                      "data-dash" : longlinea
                    });
    });

    gsap.set("#svgintro .csvgtext", {opacity:0});

    eG.timeLineLogo = gsap.to("#svgintro .snmdraw", {  duration:0.35, attr:{"stroke-dashoffset": 0},
                                    stagger: 0.25,
                                    onComplete: function() {
                                        gsap.to("#svgintro .csvgtext", {duration:1, opacity:1});
                                        gsap.to("#svgintro .snmdraw", {duration:1, opacity:0});
                                    }
                                });
};//Termina función setAnimaLogo

eG.animaLogo = function(e) {
        console.log("Animo Logo", e);

        switch ( e.type ) {
            case "mouseenter":
            gsap.set("#svgintro .csvgtext", { opacity:0 });
            gsap.set("#svgintro .snmdraw", { opacity:1 });
            //Define status original del logo
            $("#svgintro .snmdraw").each( function () {
                                var longlinea = $(this).data("dash");
                                $(this).attr("stroke-dashoffset", longlinea);
                            });
                eG.timeLineLogo.progress(0).play();
                console.log("ultima = mouseenter");
                break;
            case "click":
            case "mouseleave":
                //eG.timeLineLogo.progress(1);
                console.log("ultima = mouseleave");
                break;
        }
};//Termina función animalogo
eG.animaMobileMenu = function (e) {
    //*****
    //  Debo usar .one en vez de .on y 
    //  restituir .on en gsap onComplete
    //  De modo que no se interrumpa la animación.
    //*****
    //console.log("En menu-mobile-icon", e);
    var ham1 = "M10,29 L90,29 C90.5,29 91,29.5 91,30 C91,30.5 90.5,31 90,31 L10,31 C9.5,31 9,30.5 9,30 C9,29.5 9.5,29 10,29 z";
    var ham2 = "M10,69 L90,69 C90.5,69 91,69.5 91,70 C91,70.5 90.5,71 90,71 L10,71 C9.5,71 9,70.5 9,70 C9,69.5 9.5,69 10,69 z";
    var cross1 = "M22.4,21 L79,77.6 C79.354,77.954 79.354,78.646 79,79 C78.646,79.354 77.954,79.354 77.6,79 L21,22.4 C20.632,21.977 20.641,21.359 21,21 C21.375,20.641 22.087,20.632 22.4,21 z";
    var cross2 = "M21,77.6 L77.6,21 C77.954,20.646 78.646,20.646 79,21 C79.354,21.354 79.354,22.046 79,22.4 L22.4,79 C22.046,79.354 21.354,79.354 21,79 C20.646,78.646 20.646,77.954 21,77.6 z";
    var dur = 0.5;
    if ($("#menu-mobile-icon").hasClass("mobile-on")) {
        //*****
        //  Si mobile-on se transforma de Cross a Hamburguer
        //*****
        gsap.fromTo("#ham1", { attr:{ d:cross1 } }, { attr:{ d:ham1 }, duration: dur});
        gsap.fromTo("#ham2", { attr:{ d:cross2 } }, { attr:{ d:ham2 }, duration: dur});
        gsap.fromTo("#ham3", { opacity: 0 }, { opacity: 1, duration: dur});

    } else {
        //*****
        //  Si mobile-on se transforma de Hamburguer a Cross
        //*****
        gsap.fromTo("#ham1", { attr:{ d:ham1 } }, { attr:{ d:cross1 }, duration: dur});
        gsap.fromTo("#ham2", { attr:{ d:ham2 } }, { attr:{ d:cross2 }, duration: dur});
        gsap.fromTo("#ham3", { opacity: 1 }, { opacity: 0, duration: dur});
    }
    $("#menuwrap, #menu-mobile-icon").toggleClass("mobile-on");

    $("#menu-mobile-icon").one("click", eG.animaMobileMenu);  
};
if (eG.esGallery) {
    eG.despliegaGaleria = function(e) {
        var $this = $(".image-gallery");
        //console.log("Hey, despliega Galería", $this);
        
        $this.toggleClass("show");
        if ( $this.hasClass( "show" ) ) {
            //  Abre la galería
            //eG.animaDownArrow(true);

            $(".image-gallery div").each( function () {
                        //$(this).attr("src", $(this).data("src"));
                        $(this).css("background-image", "url(" + $(this).data("src") + ")");
                    });
            $this.css("display","grid");
            gsap.to($this, { duration: 1, height:"auto" });
        } else {
            //eG.animaDownArrow(false);
            
            gsap.to($this, { duration: 1, height:"0", onComplete: function() { $this.css("display","none");} });
        }
    };

    eG.despliegaPopup = function(e) {
    //**************************************************
    //  Función que despliega el Popup con la imagen seleccionada con Click
    //  -   Asigna las Urls de las imágenes previa y próxima a los iconos prev y next
    //  -   Asigna el indx de la imagen central a icono-close
    //      Ojo.- el indx no es el mismo en .siblings() que en .children()
    //      siblings se usa en despliegaPopup y children en popupSlide
    //  -   Asigna una nueva función on Click a la imagen seleccionada
    //      Esto se hace porque si no se acumularían las funciones en las imagenes
    //      y luego se desplegarían mil millones de cada una al dar click
    //**************************************************
        var popup = $("#img-popup");
        var arrayimg = $(this).siblings();
        var totimg = arrayimg.length;
        var thisimgindx = $(this).index();
        var nextimg = "";
        var previmg = "";
        
        if ( thisimgindx === 0 ) {
            //primer imagen
            previmg = $(arrayimg[totimg - 1]).data("src");
            nextimg = $(arrayimg[thisimgindx]).data("src");
        } else if ( thisimgindx === totimg ) {
                    //ultima imagen
                    previmg = $(arrayimg[totimg - 1]).data("src");
                    nextimg = $(arrayimg[0]).data("src");
                } else {
                    previmg = $(arrayimg[thisimgindx - 1]).data("src");
                    nextimg = $(arrayimg[thisimgindx]).data("src");
                }

        // console.log("Hey, Despliega Popup de Imagen. This: ", $(this).data("src") );
        // console.log("Indx de esta imagen", thisimgindx);
        // console.log("Numero de imágenes siblings", totimg);
        // console.log("proxima imagen", nextimg);
        // console.log("imagen anterior", previmg);
        // console.log("Array Siblings", arrayimg);
        
        //**************************************************
        //  Despliega el Popup con la imagen seleccionada con Click
        //  this es la imagen seleccionada
        //**************************************************
        $("#img-popup .backgrounded").css("background-image", "url(" + $(this).data("src") + ")" );
        popup.css("display","flex");

        //**************************************************
        //  Asigna las Urls de las imágenes previa y próxima
        //  Asigna el index de la imagen central
        //**************************************************
        $(".icon-prev").data("src", previmg);
        $(".icon-next").data("src", nextimg);
        $(".icon-close").data("indx", thisimgindx);
        //**************************************************
        //  Asigna una nueva función on Click a la imagen seleccionada
        //**************************************************
        $(this).one("click", eG.despliegaPopup);
    };

    eG.getSlideLinks = function(indx, arrayimg) {
    //**************************************************
    //  Función que obtiene y asigna las Url's de prev y next y 
    //  el nuevo index de la imagen central
    //  -   La función recibe el indx de la siguiente imagen central a desplegar y
    //      el array de imágenes de la galería
    //  -   Obtiene los parámetros que requiere para asignar Url's y nuevo indx
    //          totimg.-    es el número de imágenes en la galería
    //          indx.-      es el índice (origen 0) de la imagen a desplegar
    //  -   Calcula el índice de la nueva imagen a desplegar (imagen central)
    //      La función popupSlide envía el nuevo indice dependiendo de si el usuario
    //      dio click en prev o en next, simplemente incrementando o decrementando el
    //      valor del indice previo
    //  -   En base al nuevo índice calculado, regresa los valores de 
    //      las Url's prev y post, así como el valor del index de la nueva imagen central 
    //**************************************************
        var totimg = arrayimg.length;
        // console.log("En eG.getSlideLinks. Total de imágenes Children", totimg);
        // console.log("Index recibido en getSlideLinks", indx);
        
        switch(true) {
            case ( indx < 0 ):
                //  Se seleccionó previous image desde el slide inicial (indx = 0)
                //  La imagen central será la útima del array
                return {
                        previmg: $(arrayimg[totimg - 2]).data("src"),
                        nextimg: $(arrayimg[0]).data("src"),
                        retindx: totimg - 1
                    };
                break;
            case ( indx === 0 ):
                //  La imagen central será la primera del array
                return {
                        previmg: $(arrayimg[totimg - 1]).data("src"),
                        nextimg: $(arrayimg[1]).data("src"),
                        retindx: 0
                    };
                break;
            case ( indx === totimg - 1 ):
                //  La imagen central será la última del array
                return {
                        previmg: $(arrayimg[totimg - 2]).data("src"),
                        nextimg: $(arrayimg[0]).data("src"),
                        retindx: totimg - 1
                    };
                break
            case ( indx > totimg - 1 ):
                //  Se seleccionó next image desde el slide final (indx = totimg - 1)
                //  La imagen central será la primera del array
                return {
                        previmg: $(arrayimg[totimg - 1]).data("src"),
                        nextimg: $(arrayimg[1]).data("src"),
                        retindx: 0
                    };
                break;
            default:
                return {
                        previmg: $(arrayimg[indx - 1]).data("src"),
                        nextimg: $(arrayimg[indx + 1]).data("src"),
                        retindx: indx
                    };
                break;
        }
    };

    eG.popupSlide = function (e) {
    //**************************************************
    //  Función que despliega la siguiente imagen seleccionada con icon-prev o icon-next
    //  Asigna las Urls de las nuevas imágenes previa y próxima
    //**************************************************
        var arrayimg = $(".image-gallery").children();
        var currentIndx = $(".icon-close").data("indx");
        var direccionSlide = $(this).attr("class");
        var nextSlides = {};

        var nextIndx = (direccionSlide === "icon-next") ? 1 : -1;

        nextSlides = eG.getSlideLinks(currentIndx + nextIndx, arrayimg);

        console.log("imagen desplegada", currentIndx);
        // console.log("Hey, Despliega la siguiente imagen", this);
        // console.log("Tipo de Slide", $(this).attr("class"));
        // console.log("Despliega imagen", $(this).data("src"));
        // console.log("imagen central", $(".icon-close").data("indx"));
        // console.log("Array Children", arrayimg);
        // console.log("Next previous Image", nextSlides.previmg);
        // console.log("Next Image indx", nextSlides.retindx);
        // console.log("Next Image src", $(arrayimg[nextSlides.retindx]).data("src"));


        //**************************************************
        //  Despliega el Popup con la imagen seleccionada con Click
        //  this es la imagen seleccionada desde icon-prev o icon-next
        //**************************************************
        $("#img-popup .backgrounded").css("background-image", "url(" + $(this).data("src") + ")" );

        //**************************************************
        //  Asigna las Urls de las imágenes previa y próxima
        //  Asigna el index de la imagen central
        //**************************************************

        $(".icon-prev").data("src", nextSlides.previmg);
        $(".icon-next").data("src", nextSlides.nextimg);
        $(".icon-close").data("indx", nextSlides.retindx);

    };

    eG.cierraPopup = function (e) {
        //console.log("Hey, Cierra Popup de Imagen", this);
        e.stopPropagation();

        $("#img-popup").css("display","none");
        $("#img-popup .backgrounded").css("background-image", "none" );
    };

    eG.despliegaVideos = function(e) {
        var $this = $(".video-gallery");
        //console.log("Hey, despliega Galería", $this);
        
        $this.toggleClass("show");
        if ( $this.hasClass( "show" ) ) {
            //  Abre la galería de videos
            //eG.animaDownArrow(true);

            //  Aquí pongo el video init code
            //  Video mediaqueries
            switch (true) {
                case (eG.anchoViewport <= 320):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 320,
                                      "height" : 180
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 336):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 336,
                                      "height" : 189
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 352):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 352,
                                      "height" : 198
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 368):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 368,
                                      "height" : 207
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 384):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 384,
                                      "height" : 216
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 400):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 400,
                                      "height" : 225
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 416):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 416,
                                      "height" : 234
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 432):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 432,
                                      "height" : 243
                                    });
                    });
                    break;
                case (eG.anchoViewport <= 448):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 448,
                                      "height" : 252
                                    });
                    });
                    break;
                case (eG.anchoViewport < 560):
                    $("iframe").each( function () {
                        $(this).attr({"width" : 464,
                                      "height" : 261
                                    });
                    });
                    break;
            }//Termina switch Video-MediaQueries 
            

            $this.css("display","block");
            gsap.to($this, { duration: 0.5, height:"auto" });

        } else {
            //eG.animaDownArrow(false);
            
            gsap.to($this, { duration: 0.5, height:"0", onComplete: function() { $this.css("display","none");} });
        }
    };

    eG.noMoreLoads = 0;
    eG.despliega360s = function () {
    //**************************************************
    //  Función que despliega la galería de imágenes 360
    //  Solo entra aquí si existe una galería de imágenes 360 en la página
    //  Crea un vector con los datos de las imágenes y las despliega
    //**************************************************
        var $this = $(".img360-gallery");
        var $thisProyect = $this.attr("id");
        var arrimg = [];
        var viewers = [];
        var arrImgLength = 1;
        var tipoProyecto = "habitat";
        var i = 0;
        var iimg = "";
        
        console.log("Hey, despliega Galería", $this);
        console.log("Proyecto: ", $thisProyect);

        $this.toggleClass("show");
        if ( $this.hasClass( "show" ) ) {
            //  Abre la galería de imagenes 360
            //eG.animaDownArrow(true);
            //**************************************************
            //  
            //  Define los parámetros para desplegar las imágenes
            //  
            //  arrImgLength.-  representa el número de imágenes 360 
            //                  a desplegar en un proyecto dado.
            //  
            //  tipoProyecto .- Define si es habitat u otras-obras
            //  
            //**************************************************
            
            //**************************************************
            //  
            //  Define el número de imágenes en función al nombre del proyecto
            //
            //**************************************************
            switch ( $thisProyect ) {
                case "el-tiburon":
                    arrImgLength = 2;
                    break;
                case "el-hongo":
                    arrImgLength = 3;
                    break;
                case "la-casa-organica":
                case "oasis-productivo":
                    arrImgLength = 4;
                    break;
                case "nido-de-quetzalcoatl":
                    arrImgLength = 5;
                    break;
                default:
                    arrImgLength = 1;
                    break;
            }

            //**************************************************
            //  
            //  Define el tipo de proyecto
            //
            //**************************************************
            if ( $thisProyect === "oasis-productivo" ) { tipoProyecto = "otras-obras"; }

            //**************************************************
            //  
            //  Crea un vector con los datos de las imágenes a desplegar
            //
            //**************************************************
            for (i = 1; i <= arrImgLength; i++) {
                iimg = ("0000" + i).slice(-3);
                arrimg[i] = "/images/" + tipoProyecto + "/" + $thisProyect + "/img360-" + iimg + ".jpg";
                console.log("vector " + i + ": ", arrimg[i]);
            }
            

            $this.css("display","block");
            gsap.to($this, { 
                                duration: 0.5,
                                height:"auto",
                                onComplete: function() {
                                    //  Aquí pongo el img-360 init code
                                    //  pannellum.viewer('img360-001', {
                                    //      "type": "equirectangular",
                                    //      "panorama": "/images/habitat/la-casa-organica/img360-001.jpg",
                                    //      "preview": "/images/habitat/la-casa-organica/img360-001.jpg",
                                    //      "autoLoad":true,
                                    //      "autoRotate":-2
                                    //  });
                                    if (! eG.noMoreLoads) {
                                        for (i = 1; i <= arrImgLength; i++) {
                                            iimg = ("0000" + i).slice(-3);
                                            pannellum.viewer('img360-' + iimg, {
                                                "type": "equirectangular",
                                                "panorama": arrimg[i],
                                                "preview": arrimg[i],
                                                "autoLoad":true,
                                                "autoRotate":-2
                                            });
                                        }
                                        eG.noMoreLoads++;
                                    }
                                }
                            });

        } else {
            //  Cierra la galería de imagenes 360
            //eG.animaDownArrow(false);
            gsap.to($this, { duration: 0.5, height:"0", onComplete: function() { $this.css("display","none");} });
        }
    };
}
$(function () {
    //Asigna callback de animación a logo
    $("#alogocs").on("mouseenter click mouseleave", eG.animaLogo);
    eG.setActiveMenuOption();
    eG.setAnimaLogo();
    switch (true) {
        case eG.esIndex:
            //*****
            //
            //  On Document Ready:
            //  Creo el slider
            //
            //*****
            eS.aquiToy("hi there");
            eS.creaSlider();
            $(".snm-slideshow li>span").removeClass('lazy');
            //*****
            //
            //  Inicializo Variable Global con timer para tweenSlider
            //
            //*****
            //eG.indxTimer = eS.initSliderTimer();
            //*****
            //
            //  Asigno funciones callback a puntos index
            //
            //*****            
            $(".slidepointerwrap").on("click", eS.tweenSlider);
            //*****
            //
            //  Inicio los Sliders
            //
            //*****       
            eS.tweenSlider(1);            
            //*****
            //
            //  Inicializo observador de visibilidad
            //
            //*****            
            eS.watchVisible();
            break;
        case eG.esOmedios:
            break;
        default:
            break;
    }//Termina switch paginas
    
    //Asigna callbacks
    $("#menu-mobile-icon").one("click", eG.animaMobileMenu);
    
    if (eG.esGallery) {
        $(".tipogaleria").on("click", eG.despliegaGaleria);
        $(".image-gallery div").one("click", eG.despliegaPopup);
        //$(".image-gallery img").one("click", eG.despliegaPopup);
        $("#img-popup .icon-close").on("click", eG.cierraPopup);
        $("#img-popup .icon-prev").on("click", eG.popupSlide);
        $("#img-popup .icon-next").on("click", eG.popupSlide);

        // Videos
        $(".tipovideo").on("click", eG.despliegaVideos);

        // 360's
        //Despliega 360s solo si existe la galería 360
        if ( $( ".img360-gallery" ).length ) {
            $(".tipo360").on("click", eG.despliega360s);
        }
    }

    //*************************************         Sección de Funciones Utilitarias
    $(window).on("resize", function() {
        eG.recalcWinPars();
    });//Termina función on resize
}); //Termina document.ready function
